import { Box, styled } from "@mui/material";

export const Wrapper = styled(Box)(() => ({
  borderTopLeftRadius: "0.5rem",
  borderTopRightRadius: "0.5rem",
  overflowY: "auto",
  width: "100%",
}));
